import { ProfileApi } from '../../api';
import axios from '../axios';

const profileApi = new ProfileApi(undefined, undefined, axios);

export default profileApi;
